import React from "react";
import './coursesoffstyle.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faBookOpen, faChartLine, faClock, faCheckCircle, faAward } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import bazeleconta from '../../imagesHome/bazeleconta.png';

const BazeleConta = () => {
  return (
    <div className="general-frame-bc-cf">
    <div className="general-frame-bazeleconta">
      <section className="bc-hero-shell">
        <div className="breadcrumb-bc">
          <span>Cursuri</span>
          <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
          <span className="current">Bazele Contabilitatii</span>
        </div>

        <div className="bc-main-section">
          <div className="bc-main-left">
            <img src={bazeleconta} alt="bazele conta" />
            <p className="bc-kicker">Curs de baza</p>
            <h1>Bazele Contabilitatii</h1>
            <p>
              Contabilitatea este limbajul afacerilor – modul prin care o firma isi inregistreaza, analizeaza si raporteaza activitatile economice.
            </p>
            <p>
              In acest curs vei descoperi conceptele fundamentale: active, pasive, capitaluri proprii, venituri si cheltuieli. Vei intelege cum se construieste bilantul, cum functioneaza conturile si cum sa interpretezi informatiile financiare de baza.
            </p>
            <p>
              Nu ai nevoie de cunostinte anterioare - totul este explicat simplu, cu exemple practice si exercitii interactive.
            </p>

            <div className="bc-hero-actions">
              <Link to="/quiz-start" className="bc-primary-link">Incepe cursul</Link>
              <Link to="/cursuri-prezentare" className="bc-secondary-link">Vezi toate cursurile</Link>
            </div>
          </div>

          <div className="bc-main-right">
            <div className="bc-card">
              <div className="bc-card-badge">Incepatori</div>
              <h2>Invata in ritmul tau</h2>
              <p>Acceseaza cursul "Bazele Contabilitatii" si incepe sa lucrezi pe exemple clare, pas cu pas.</p>

              <div className="bc-highlights">
                <div className="bc-highlight-item">
                  <FontAwesomeIcon icon={faClock} />
                  <span>50+ lectii explicate simplu</span>
                </div>
                <div className="bc-highlight-item">
                  <FontAwesomeIcon icon={faBookOpen} />
                  <span>Continut structurat progresiv</span>
                </div>
                <div className="bc-highlight-item">
                  <FontAwesomeIcon icon={faChartLine} />
                  <span>Exemple si exercitii aplicate</span>
                </div>
              </div>

              <Link to="/quiz-start" className="bc-card-button">Creeaza cont gratuit</Link>
            </div>
          </div>
        </div>
      </section>

    </div>
      
      {/* 🔹 Secțiunea 2: Ce vei învăța */}
      <div className="cadru-bazeleconta-second">
        <div className="what-you-learn-section">
          <h2 className="section-title-bc">Ce vei invata in acest curs</h2>
          <p className="section-subtitle-bc">
            Parcurgi conceptele fundamentale ale contabilitatii, pas cu pas, cu exemple practice si exercitii interactive.
          </p>

          <div className="modules-grid-bc">
            {/* Modul 1 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 1</div>
              <h3 className="module-title-bc">Introducere in contabilitate</h3>
              <p className="module-desc-bc">
                Descopera ce este contabilitatea, de ce este importanta si cum te ajuta sa intelegi afacerile.
              </p>
            </div>

            {/* Modul 2 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 2</div>
              <h3 className="module-title-bc">Patrimoniul intreprinderii</h3>
              <p className="module-desc-bc">
                Intelege structura patrimoniului si elementele care definesc situatia economica a unei firme.
              </p>
            </div>

            {/* Modul 3 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 3</div>
              <h3 className="module-title-bc">Contul si dubla inregistrare</h3>
              <p className="module-desc-bc">
                Inveti cum functioneaza conturile si cum se aplica principiul dublei inregistrari.
              </p>
            </div>

            {/* Modul 4 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 4</div>
              <h3 className="module-title-bc">Activele</h3>
              <p className="module-desc-bc">
                Studiezi activele firmei, clasificarea lor si rolul pe care il au in activitatea economica.
              </p>
            </div>

            {/* Modul 5 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 5</div>
              <h3 className="module-title-bc">Datoriile</h3>
              <p className="module-desc-bc">
                Află ce inseamna datoriile unei intreprinderi si cum influenteaza echilibrul financiar.
              </p>
            </div>

            {/* Modul 6 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 6</div>
              <h3 className="module-title-bc">Capitalurile proprii</h3>
              <p className="module-desc-bc">
                Inveti ce reprezinta capitalurile proprii si cum apar in structura patrimoniului.
              </p>
            </div>

            {/* Modul 7 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 7</div>
              <h3 className="module-title-bc">Veniturile si cheltuielile</h3>
              <p className="module-desc-bc">
                Descopera cum se formeaza rezultatul exercitiului prin analiza veniturilor si cheltuielilor.
              </p>
            </div>

            {/* Modul 8 */}
            <div className="module-card-bc">
              <div className="module-label-bc">Modul 8</div>
              <h3 className="module-title-bc">Evaluarea elementelor patrimoniale</h3>
              <p className="module-desc-bc">
                Parcurgi regulile de evaluare pentru elementele patrimoniale si modul in care se reflecta in contabilitate.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 3: Statistici curs */}
      <div className="stats-section-bc">
        <div className="stats-container-bc">
          <h2 className="section-title-bc">Ce include cursul</h2>
          
          <div className="stats-grid-bc">
            <div className="stat-item-bc">
              <div className="stat-number-bc">100+</div>
              <div className="stat-label-bc">Lectii interactive</div>
            </div>

            <div className="stat-item-bc">
              <div className="stat-number-bc">100+</div>
              <div className="stat-label-bc">Quiz-uri</div>
            </div>

            <div className="stat-item-bc">
              <div className="stat-number-bc">100+</div>
              <div className="stat-label-bc">Aplicatii practice</div>
            </div>

            <div className="stat-item-bc">
              <div className="stat-number-bc">8</div>
              <div className="stat-label-bc">Teste de final de modul</div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 4: Beneficii */}
      <div className="benefits-section-bc">
        <div className="benefits-container-bc">
          <h2 className="section-title-bc">De ce sa alegi ContaLearn</h2>
          
          <div className="benefits-list-bc">
            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Inveti in ritmul tau</h4>
                <p>Acceseaza lectiile oricand, de oriunde - pe web sau mobile</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Exercitii interactive</h4>
                <p>Nu doar teorie - aplici imediat ce inveti prin jocuri si teste</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Feedback instant</h4>
                <p>Afli imediat daca raspunsul tau este corect si de ce</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Urmareste-ti progresul</h4>
                <p>Vezi cat ai avansat si ce mai ai de invatat</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Certificat de absolvire</h4>
                <p>Primesti un certificat oficial dupa finalizarea cursului</p>
              </div>
            </div>

            <div className="benefit-item-bc">
              <div className="benefit-check-bc">✓</div>
              <div>
                <h4>Zero cunostinte necesare</h4>
                <p>Perfect pentru incepatori - incepem de la baza</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 5: Final CTA */}
      <div className="final-cta-bc">
        <div className="cta-content-bc">
          <h2>Gata sa incepi?</h2>
          <p>Inregistreaza-te gratuit si incepe sa inveti contabilitate astazi, direct din platforma.</p>
          <div className="cta-buttons-bc">
            <Link to="/quiz-start" className="bc-primary-link bc-cta-link">Creeaza cont gratuit</Link>
            <div className="sau-cta-bc">sau</div>
            <Link to="/cursuri-prezentare" className="bc-secondary-link bc-cta-link">Vezi toate cursurile</Link>
          </div>
        </div>
      </div>

    </div>
  );
};

export default BazeleConta;
